import { render } from "./UsersModal.vue?vue&type=template&id=67286e70&scoped=true"
import script from "./UsersModal.vue?vue&type=script&lang=js"
export * from "./UsersModal.vue?vue&type=script&lang=js"

import "./UsersModal.vue?vue&type=style&index=0&id=67286e70&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67286e70"]])

export default __exports__